import React from 'react';
import ScrollAnimation from '../ScrollAnimation/ScrollAnimation.js';
import { IImage } from '../../types/content';

interface IAboutItemProps {
  item: {
    image: IImage;
    title: string;
    description: string;
  };
}


const AboutItem = ({ item }: IAboutItemProps) => {
  const icon = require(`../../assets/${item.image.link}.svg`);
  const minMobile =  601;
  return (
    <div className="about_ubisoft-plus_boxes_item">
      <ScrollAnimation
        className="icon-wrapper"
        animateIn="scaleUp"
        animatePreScroll={!(window.innerWidth > minMobile)}
      >
        <img src={icon} alt={item.image.alt} />
      </ScrollAnimation>
      <ScrollAnimation
        className="content"
        animateIn="fadeUp"
        animateOnce={true}
        animatePreScroll={!(window.innerWidth > minMobile)}
      >
        <h3>{item.title}</h3>
        <p dangerouslySetInnerHTML={{ __html: item.description }} />
      </ScrollAnimation>
    </div>
  );
};

export default AboutItem;
